/**
 * BCP固定セクションの定数定義
 *
 * フロントエンドとバックエンドで同じ固定文言を使用するセクションを一元管理します。
 * これらのセクションはAI生成ではなく、事前に定義された固定テンプレートを使用します。
 */

export const BCP_FIXED_SECTIONS = {
  /**
   * 5-1. BCP発動の判断基準
   * 簡易版BCPで使用される固定の発動基準
   */
  ACTIVATION_CRITERIA_5_1: `危機事象の顕在化により、通常のオペレーションでは目標復旧時間内での復旧が困難となる可能性が発生した場合。
但し、震度6弱以上の地震が発生した場合は自動発動とする。`,

  /**
   * 3-2. 資金計画の考え方
   * 財務状況の把握と資金調達先の固定テンプレート
   */
  FINANCIAL_PLAN_3_2: `・資金繰りを定期的に確認し、緊急時に利用可能な資金を確保する。
・地元金融機関、取引銀行、政府系金融機関（日本政策金融公庫など）との連携を強化し、緊急時に迅速な資金調達ができる体制を整備する。
・地元商工会議所、金融機関担当者、専門コンサルタントに相談し、資金計画を定期的に見直す。
・資金繰りを定期的に確認し、緊急時に利用可能な資金を確保する。`,

  /**
   * 6-1. 緊急対応フロー（初動対応）
   * 地震・水害・感染症別の初動対応フロー
   */
  EMERGENCY_RESPONSE_6_1: `【地震】
ステージ1（発災・BCP発動フェーズ）：安全確保、家族との連絡確保、社員の安否確認実施、対策本部設置
ステージ2（事業再開フェーズ）：情報集約（社員の出社可否・自社資源の使用可否）、自社事業への影響分析
ステージ3（業務回復フェーズ）：重要業務を現地復旧（困難な場合は、現地復旧以外の戦略）
ステージ4（全面回復フェーズ）：全業務の順次回復

【水害】
ステージ1（自然災害の発生）：情報収集、避難場所の確認や周知、備蓄品の点検
ステージ2（BCP発動フェーズ）：BCP発動の判断、社員の安否確認、重要資産の確認と移動
ステージ3（事業再開フェーズ）：情報集約（社員の出社可否・自社資源の使用可否）、自社事業への影響分析
ステージ4（業務回復フェーズ）：重要業務を現地復旧（困難な場合は、現地復旧以外の戦略）
ステージ5（全面回復フェーズ）：全業務の順次回復

【感染症】
ステージ1（感染症発生）：BCP発動基準に該当する情報の収集・確認
ステージ2（BCP発動フェーズ）：BCP発動の判断、感染防止対策の実施
ステージ3（事業回復フェーズ）：在宅勤務・リモートワーク体制の構築
ステージ4（全面回復フェーズ）：全業務の順次回復`,

  /**
   * 6-2. 対策本部の立ち上げ
   * 対策本部の構成メンバーと役割分担
   */
  ROLES_RESPONSIBILITIES_6_2: `本部長：{役職名を入力}

【初期対応チーム】
・メンバー：{役職名を入力}
・役割：安否情報集約、各設備の被害状況集約、従業員の対応計画、負傷者対応

【復旧対応チーム】
・メンバー：{役職名を入力}
・役割：重要事業の実施体制検討、システム状況対応、資金繰り管理、各種情報収集（災害情報、協力会社、他社の状況等）、情報発信`,

  /**
   * 6-3. 緊急時の連絡手段
   * 従業員間の連絡方法
   */
  COMMUNICATION_METHODS_6_3: `従業員間の連絡方法:
- メール
- SNS（LINE等でグループ作成）
- 電話
- その他`,

  /**
   * 7-1. 定期訓練
   * 訓練計画と実施頻度
   */
  REGULAR_TRAINING_7_1: `【訓練計画】
・避難訓練：年1回以上
・安否確認訓練：年2回
・業務復旧シミュレーション：年1回
・緊急連絡訓練：四半期ごと

【訓練内容】
・避難経路の確認と実地訓練
・安否確認システムの動作確認
・代替拠点での業務継続訓練
・備蓄品の使用方法確認

【評価と改善】
・訓練後にアンケートを実施
・課題を洗い出し、BCPに反映
・次回訓練計画に改善点を組み込む`,

  /**
   * 7-2. BCPの定期見直し
   * 見直しルールと更新頻度
   */
  BCP_REVIEW_7_2: `【見直し頻度】
・定期見直し：年1回（4月）
・臨時見直し：重大な組織変更、大規模災害発生時、訓練で重大な問題が発見された時

【見直し担当者】
・責任者：総務部長
・実務担当：総務課長、各部門代表者

【見直し項目】
・組織体制の変更（人事異動、組織改編）
・連絡先情報の更新
・重要業務の変更
・新たなリスクの追加
・訓練結果の反映
・法規制の変更対応

【承認プロセス】
1. 各部門からの変更提案収集
2. 総務部による原案作成
3. 経営会議での審議
4. 社長承認
5. 全社員への周知`,

  /**
   * 7-3. 従業員教育
   * 教育・研修計画
   */
  EMPLOYEE_EDUCATION_7_3: `【新入社員研修】
・入社時にBCPの基本方針を説明
・避難経路と集合場所の確認
・安否確認システムの使用方法習得

【定期研修】
・年1回、全社員向けBCP研修を実施
・部門別の役割確認
・緊急時の行動手順の確認

【緊急時行動指針】
・発災時の安全確保方法
・避難場所と避難経路
・安否確認の報告方法
・出社可否の判断基準
・在宅勤務時の業務継続方法

【教育資料】
・BCPハンドブック（全社員配布）
・緊急時連絡先一覧
・避難経路図
・重要業務手順書

【理解度確認】
・研修後にテストを実施
・理解度が低い項目は追加研修
・訓練での実践的な確認`,
} as const;

/**
 * セクションIDから固定セクションを取得するヘルパー関数
 */
export const getFixedSectionContent = (sectionId: string): string | null => {
  const sectionMap: Record<string, keyof typeof BCP_FIXED_SECTIONS> = {
    'activationCriteria': 'ACTIVATION_CRITERIA_5_1',
    'financialPlan': 'FINANCIAL_PLAN_3_2',
    'emergencyOrganization': 'EMERGENCY_RESPONSE_6_1',
    'rolesResponsibilities': 'ROLES_RESPONSIBILITIES_6_2',
    'communicationMethods': 'COMMUNICATION_METHODS_6_3',
    'regularTraining': 'REGULAR_TRAINING_7_1',
    'bcpReview': 'BCP_REVIEW_7_2',
    'employeeEducation': 'EMPLOYEE_EDUCATION_7_3',
  };

  const key = sectionMap[sectionId];
  return key ? BCP_FIXED_SECTIONS[key] : null;
};
